import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { responsive } from "../../utils/style";
import { useNavigate } from "react-router-dom";

const PrivacyNotice = () => {
  const url =
    process.env.REACT_APP_FRONTEND_URL || "https://webapp.sonkthaiglairok.com";

  const indent = (times = 1) => {
    const indentCode = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;

    let result = [];
    for (let i = 0; i < times; ++i) result.push(indentCode);

    return result;
  };

  const navigate = useNavigate();
  return (
    <Background>
      <Container>
        <ContentContainer>
          <center>
            <Topic>คำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)</Topic>
          </center>
          <center>
            <SubTopic>
              ของ เว็บแอปพลิเคชัน เณรกล้า โภชนาดี และแบบทดสอบชุดความรู้ เณรกล้า
              โภชนาดี
            </SubTopic>
          </center>
          <Text>
            {indent()}
            สื่อโภชนาการในรูปแบบของเว็บแอปพลิเคชันและแบบทดสอบชุดความรู้ “เณรกล้า
            โภชนาดี” (“เว็บแอปฯ”) จัดทำขึ้น
            เพื่อช่วยให้สามเณรในระดับชั้นมัธยมศึกษาในโรงเรียนพระปริยัติธรรมทั่วประเทศไทย
            ได้รับการสร้างเสริมภาวะโภชนาการที่ดี
            โดยมีครูซึ่งรับผิดชอบในรายวิชาสุขศึกษา
            ซึ่งอาจเป็นพระสงฆ์ที่เป็นพระอาจารย์หรือครูฆราวาส
            เป็นผู้ดูแลสามเณรในการใช้เว็ปแอปฯ
            เพื่อเป็นกิจกรรมเสริมหลักสูตรและการให้ความรู้ทางโภชนาการ
            โดยการมีส่วนร่วมของสามเณรในการกรอกข้อมูล 4 ประเด็น คือ ปริมาณการฉัน
            นมวัว ผัก น้ำหวาน และระยะเวลาการออกกำลังกายต่อวัน สัปดาห์ละ 1 ครั้ง
            ภายในระยะเวลาที่ครูกำหนด ตั้งแต่ 4 - 16 สัปดาห์ โดยตั้งเป้าหมาย ทั้ง
            4
            ประเด็นเพื่อให้สามเณรมีภาวะโภชนาการที่ดีและมีสุขภาพร่างกายที่แข็งแรง
            นอกจากนั้น
            สามเณรหรือครูผู้รับผิดชอบอาจเลือกที่จะกรอกข้อมูลภาวะโภชนาการของสามเณร
            1-2 ครั้งในช่วงที่มีการแข่งขัน ตามความสมัครใจ
            อีกทั้งยังให้สามเณรสามารถทำแบบทดสอบชุดความรู้เพื่อการพัฒนาความรอบรู้ทางโภชนาการซึ่งนำไปใช้ในชีวิตประจำวันได้
          </Text>
          <Text>
            {indent()}เนื่องด้วยเว็บแอปฯ มีการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน ผู้ดูแลเว็บแอปฯ
            จึงจำเป็นต้องจัดทำ คำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)
            ฉบับนี้ขึ้น เพื่อให้เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ. 2562 ผู้ดูแลเว็บแอปฯ
            ตระหนักและให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคล
            และถือปฏิบัติอย่างเคร่งครัดในเรื่องการเคารพสิทธิความเป็นส่วนตัวของเจ้าของข้อมูลส่วนบุคคล
            คำประกาศฯ ฉบับนี้จึงจัดทำขึ้นเพื่อให้ท่านในฐานะ
            <BoldText>
              ผู้ใช้งานเว็บแอปฯ
            </BoldText> (ซึ่งต่อไปในประกาศนี้เรียกว่า{" "}
            <BoldText>“เจ้าของข้อมูลส่วนบุคคล”</BoldText>)
            ได้ทราบและเข้าใจรูปแบบ วิธีการ
            และวัตถุประสงค์และความจำเป็นของผู้ดูแลเว็บแอปฯ
          </Text>
          <Text>
            {indent()}ดังนั้น ผู้ดูแลเว็บแอปฯ
            ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลตามพระราชบัญญัติฯ ดังกล่าว
            มีหน้าที่ต้องดำเนินการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลจากท่าน
            รวมทั้งกำหนดนโยบายการคุ้มครองข้อมูลส่วนบุคคล
            มาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล
            ตลอดจนสิทธิตามกฎหมายของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
            โดยคำประกาศฉบับนี้มีผลบังคับใช้กับเจ้าของข้อมูลส่วนบุคคลที่เป็นผู้ใช้งาน
            ทั้งในการลงทะเบียนใช้งาน กรอกข้อมูล 4 เป้าหมายและข้อมูลภาวะโภชนาการ
            การทำแบบทดสอบชุดความรู้ รวมถึงกิจกรรมออนไลน์อื่นๆ
            ที่กระทำผ่านเว็บแอปฯ
          </Text>
          <SubTopic>1. คำนิยาม</SubTopic>
          <Text>
            {indent()}
            <BoldText>“ข้อมูลส่วนบุคคล”</BoldText> หมายความถึง
            ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
            แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
            ซึ่งในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้จะหมายถึงข้อมูลส่วนบุคคลของผู้ใช้งานเว็บแอปฯ
            <br />
            {indent()}
            <BoldText>“ผู้ควบคุมข้อมูลส่วนบุคคล”</BoldText> หมายถึง
            ผู้ที่มีอำนาจหน้าที่ตัดสินใจการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งานเข้ามาใช้บริการ
            ซึ่งในบริบทของคำประกาศเกี่ยวกับความเป็นส่วนตัวฉบับนี้จะหมายถึง
            ผู้ดูแลเว็บแอปฯ ซึ่งเป็นเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
            ตามคำประกาศฯ นี้
            <br />
            {indent()}
            <BoldText>“ผู้ใช้งาน”</BoldText> ผู้ที่เข้าใช้เว็บแอปฯ
            ซึ่งอาจเป็นเจ้าของข้อมูลส่วนบุคคล หรือไม่ก็ได้ ได้แก่ <br />
            {indent(2)}
            <BoldText>“สามเณร”</BoldText>
            หมายถึง สามเณรผู้ที่ร่วมการแข่งขัน หรือกรอกข้อมูล 4
            เป้าหมายหรือข้อมูลภาวะโภชนาการ หรือทำแบบทดสอบชุดความรู้
            <br />
            {indent(2)}
            <BoldText>“ครู”</BoldText> หมายถึง พระสงฆ์ที่เป็นพระอาจารย์
            หรือครูฆราวาส ที่เป็นผู้ดูแลสามเณรในรายวิชาสุขศึกษา
            ที่อาจเป็นผู้สร้างการแข่งขัน
            หรือเป็นผู้ติดตามพัฒนาการด้านโภชนาการของสามเณร
            หรือเป็นโค้ชดูแลการใช้งานเว็บแอปฯ
          </Text>
          <SubTopic>
            2. วัตถุประสงค์ในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน
          </SubTopic>
          <Text>
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้งานเพื่อวัตถุประสงค์
            ดังต่อไปนี้
            <br />
            {indent()}
            <BoldText>2.1.</BoldText>{" "}
            เพื่อให้สามเณรระดับมัธยมศึกษาในโรงเรียนพระปริยัติธรรมของประเทศไทย
            มีการปรับเปลี่ยนพฤติกรรมการฉันอาหารและการออกกำลังกายให้เหมาะสม
            และเอื้อให้มีสุขภาพแข็งแรงและลดความเสี่ยงโรคเรื้อรังในระยะยาว
            <br />
            {indent()}
            <BoldText>2.2.</BoldText>{" "}
            เพื่อความจำเป็นในการดำเนินการติดตามประเด็นอาหารและโภชนาการ ให้คะแนน
            และจัดอันดับผู้ที่ปฏิบัติได้ถึงเป้าหมาย
            และมอบรางวัลแบบออนไลน์ตามกติกาที่ระบุไว้ ซึ่งเป็นบริการของเว็บแอปฯ
            <br />
            {indent()}
            <BoldText>2.3.</BoldText>{" "}
            เพื่อให้สามเณรและพระอาจารย์หรือครูสุขศึกษาได้ทราบพัฒนาการการฉันผัก
            เครื่องดื่ม การออกกำลังกาย และภาวะโภชนาการของสามเณร
            <br />
            {indent()}
            <BoldText>2.4.</BoldText>{" "}
            เพื่อให้สามเณรและครูได้ทราบผลการทดสอบความรู้จากสื่อชุดความรู้
            เณรกล้า โภชนาดี
            <br />
          </Text>
          <SubTopic>
            3. หลักการในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล
          </SubTopic>
          <Text>
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลพิจารณากำหนดฐานกฎหมายในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลตามความเหมาะสมและตามบริบทของการให้บริการ
            โดยฐานกฎหมายหลักที่ผู้ควบคุมข้อมูลใช้ในการประมวลผลข้อมูลส่วนบุคคลมีดังนี้
            <br />
            {indent()}
            <BoldText>3.1 ความยินยอมของเจ้าของข้อมูลส่วนบุคคล </BoldText>
            <br />
            {indent(2)}เพื่อการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ควบคุมข้อมูลที่จำเป็นต้องได้รับความยินยอม
            โดยได้แจ้งวัตถุประสงค์ของการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลก่อนหรือขณะขอความยินยอม อาทิเช่น
            การลงทะเบียนของผู้ใช้งาน การคิดคะแนน การจัดอันดับ และการให้รางวัล
            เป็นต้น ทั้งนี้ให้รวมถึงการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวซึ่งไม่เข้าข้อยกเว้นตามกฎหมายด้วย
            <br />
            {indent()}
            <BoldText>
              3.2
              เพื่อบรรลุวัตถุประสงค์เกี่ยวกับการศึกษาวิจัยหรือเก็บข้อมูลทางสถิติ
            </BoldText>
            <br />
            {indent()}
            {indent()}
            เพื่อการวิเคราะห์ข้อมูลสำหรับการศึกษาวิจัยหรือเก็บข้อมูลทางสถิติ
            ตลอดจนการประมวลผลข้อมูลเพื่อให้ได้มาซึ่งผลลัพธ์ของการศึกษาวิจัยและเก็บข้อมูลทางสถิติ
            ดังกล่าว อย่างไรก็ตามการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลเพื่อประโยชน์ในการศึกษาวิจัยและสถิตินั้นจะอยู่ควบคู่ไปกับฐานความยินยอมในข้อ
            3.1
            และผู้ควบคุมข้อมูลส่วนบุคคลได้จัดให้มีมาตรการการคุ้มครองข้อมูลส่วนบุคคลที่เหมาะสมตามที่ปรากฏในข้อ
            10. ของคำประกาศฯ ฉบับนี้
          </Text>
          <SubTopic>
            4. ข้อมูลส่วนบุคคลของผู้ใช้งานที่ผู้ดูแลเว็บแอปฯ เก็บรวบรวม ใช้
            และเปิดเผย
          </SubTopic>
          <Text>
            {indent()}
            <BoldText>
              4.1. แหล่งข้อมูลและรายการข้อมูลส่วนบุคคลที่เก็บรวบรวม มีดังนี้
            </BoldText>
            <br />
            {indent()}1. เก็บข้อมูลจากผู้ใช้งานโดยตรงผ่าน การลงทะเบียน /
            การใช้งานเว็ปแอปฯ (ต้องลงทะเบียนหรือเข้าสู่ระบบก่อน)
            <br />
            {indent()}
            <BoldText>
              กรณีลงทะเบียนเพื่อใช้เว็บแอปพลิเคชัน เณรกล้า โภชนาดี
              และทำแบบทดสอบชุดความรู้
            </BoldText>
            <br />
            {indent()}- ชื่อ ชื่อเล่น ชั้นเรียน ห้องเรียน รหัสผ่าน บทบาท
            (สามเณร, ครู) รหัสผ่าน <br />
            {indent()}- ข้อมูลการฉัน นม ผัก น้ำหวาน และการออกกำลังกาย
            <br />
            {indent()}- ข้อมูลภาวะโภชนาการ ได้แก่ น้ำหนัก ส่วนสูง
            ภาวะโภชนาการเกี่ยวกับน้ำหนักและความสูง
            <br />
            {indent()}
            <BoldText>
              กรณีลงทะเบียนเฉพาะทำแบบทดสอบชุดความรู้เพียงอย่างเดียว
            </BoldText>
            <br />
            {indent()}- ชื่อสมมุติ รหัสผ่าน
            <br />
            {indent()}
            <BoldText>4.2. จุดประสงค์การใช้งานข้อมูลส่วนบุคคล</BoldText>
            <br />
            {indent(2)}4.2.1.
            สำหรับผู้ประสงค์ใช้ทั้งเว็บแอปพลิเคชันและทำแบบทดสอบชุดความรู้
            เณรกล้า โภชนาดี
            <br />
            {indent(2)}1. เพื่อการลงทะเบียน สมัครใช้บริการ ข้อมูลส่วนบุคคลที่ใช้
            คือ
            <br />
            {indent(2)}- ชื่อ ชื่อเล่นสามเณร ชั้นเรียน ห้องเรียน รหัสผ่าน
            <br />
            {indent(2)}- ชื่อสมมุติ และรหัสผ่านของครู
            <br />
            {indent(2)}2. เพื่อคิดคะแนน การฉัน ผัก เครื่องดื่ม และการออกกำลังกาย
            ข้อมูลส่วนบุคคลที่ใช้คือ
            <br />
            {indent(2)}- ข้อมูลการฉันนม ผัก น้ำหวาน และการออกกำลังกาย
            <br />
            {indent(2)}3. เพื่อติดตามพัฒนาการของการฉันผัก
            เครื่องดื่มและการออกกำลังกายของสามเณร ข้อมูลส่วนบุคคลที่ใช้คือ
            <br />
            {indent(2)}- ข้อมูลการฉันนม ผัก น้ำหวาน และการออกกำลังกาย
            <br />
            {indent(2)}- ข้อมูล น้ำหนัก ส่วนสูงและภาวะโภชนาการ
            <br />
            {indent(2)}4. เพื่อจัดอันดับของการฉันผัก
            เครื่องดื่มและการออกกำลังกายของสามเณร ตามแต่ละชั้นเรียน ห้องเรียน
            เป็นต้น ข้อมูลส่วนบุคคลที่ใช้คือ
            <br />
            {indent(2)}- ข้อมูลการฉันนม ผัก น้ำหวาน และการออกกำลังกาย
            <br />
            {indent(2)}- ข้อมูลชื่อ ชื่อเล่นสามเณร ชั้นเรียน ห้องเรียน
            <br />
            {indent(2)}5. เพื่อให้รางวัล (เป็นสติ๊กเกอร์ออนไลน์)
            เมื่อเข้าเกณฑ์รางวัลการฉันผัก เครื่องดื่มและการออกกำลังกาย
            ข้อมูลส่วนบุคคลที่ใช้คือ
            <br />
            {indent(2)}- ข้อมูลการฉันนม ผัก น้ำหวาน และการออกกำลังกาย
            <br />
            {indent(2)}- ข้อมูลชื่อ ชื่อเล่นสามเณร ชั้นเรียน ห้องเรียน
            <br />
            {indent(2)}4.2.2. สำหรับผู้ประสงค์เฉพาะทำแบบทดสอบชุดความรู้ เณรกล้า
            โภชนาดี เพียงอย่างเดียว
            <br />
            {indent(2)}1. เพื่อการลงทะเบียน สมัครใช้บริการ ข้อมูลส่วนบุคคลที่ใช้
            คือ
            <br />
            {indent(2)}- ชื่อสมมุติ รหัสผ่าน ของผู้ทำแบบทดสอบ
            <br />
            <br />
            อนึ่ง สำหรับการจัดเก็บคุกกี้ (Cookie) ของเว็บแอปฯ จะดำเนินการตาม
            นโยบายคุกกี้ ซึ่งปรากฎตาม{" "}
            <Link onClick={() => navigate("/cookiePolicy")}>
              {url + "/cookiePolicy"}
            </Link>{" "}
          </Text>
          <SubTopic>5. การเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน</SubTopic>
          <Text>
            {indent()}
            <BoldText>5.1 </BoldText>
            ผู้ควบคุมข้อมูลส่วนบุคคลจะไม่เปิดเผยข้อมูล
            ให้กับบุคคลที่ไม่ได้เกี่ยวข้องกับการกระทำใด ๆ
            เพื่อให้บรรลุวัตถุประสงค์ในข้อ 2. เว้นแต่เป็นการปฏิบัติตามกฎหมาย
            หรือเป็นสิทธิของผู้ควบคุมข้อมูลอันพึงกระทำได้ตามกฎหมาย <br />
            {indent()}
            <BoldText>5.2 </BoldText>
            เพื่อให้บรรลุวัตถุประสงค์ในข้อ 2.
            ผู้ควบคุมข้อมูลส่วนบุคคลอาจเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งานต่อบุคคลหรือนิติบุคคลดังต่อไปนี้
            <br />
            {indent()}
            {indent()}
            <BoldText>5.2.1 </BoldText>ผู้ให้บริการคลาวด์ (Cloud Platform) คือ
            Digital Ocean เพื่อให้ผู้ใช้สามารถใช้งานเว็บแอปฯ
            <br />
            {indent()}
            {indent()}
            <BoldText>5.2.2 </BoldText>บุคคลอื่น
            ที่จำเป็นเพื่อการให้บริการแก่ผู้ใช้งาน รวมถึงดำเนินการใด ๆ
            เพื่อให้บรรลุหรือเป็นไปตามวัตถุประสงค์ในข้อ 2.
            <br />
            {indent()}
            {indent()}
          </Text>
          <SubTopic>
            6. การส่งหรือโอนข้อมูลส่วนบุคคลของผู้ใช้งานไปยังต่างประเทศ
          </SubTopic>
          <Text>
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลอาจมีการโอนข้อมูลของผู้ใช้งานไปยังผู้ให้บริการคลาวด์
            ทั้งนี้ เพื่อประโยชน์ของผู้ใช้งาน หรือเพื่อให้บรรลุวัตถุประสงค์ในข้อ
            2.
            ซึ่งข้อมูลดังกล่าวจะได้รับความคุ้มครองตามมาตรฐานการคุ้มครองข้อมูลส่วนบุคคล
          </Text>
          <SubTopic>
            7. สิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒
            ของผู้ใช้งาน
          </SubTopic>
          <Text>
            {indent()}
            <BoldText>7.1 </BoldText>สิทธิในการเข้าถึง
            รับสำเนาและขอให้เปิดเผยที่มาของข้อมูลส่วนบุคคลของผู้ใช้งานที่ผู้ควบคุมข้อมูล
            เก็บรวบรวมอยู่
            เว้นแต่กรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลมีสิทธิปฏิเสธคำขอของผู้ใช้งานตามกฎหมายหรือคำสั่งศาล
            หรือกรณีที่คำขอของผู้ใช้งานจะมีผลกระทบที่อาจก่อให้เกิดความเสียหายต่อสิทธิและเสรีภาพของบุคคลอื่น
            <br />
            {indent()} <BoldText>7.2 </BoldText>
            สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของผู้ใช้งานที่ไม่ถูกต้องหรือไม่ครบถ้วน
            เพื่อให้มีความถูกต้อง เป็นปัจจุบัน สมบูรณ์
            และไม่ก่อให้เกิดความเข้าใจผิด <br />
            {indent()}
            <BoldText>7.3 </BoldText>
            สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคลของผู้ใช้งานในกรณีหนึ่งกรณีใดดังต่อไปนี้
            (กรณีที่ผู้ใช้งานสามารถใช้สิทธิได้ตามมาตรา 34
            และสอดคล้องกับงานของผู้ใช้งาน)
            <br />
            <BoldText>
              {indent()}
              {indent()}7.3.1{" "}
            </BoldText>
            เมื่ออยู่ในช่วงเวลาที่ผู้ควบคุมข้อมูลส่วนบุคคลทำการตรวจสอบตามคำร้องขอของผู้ใช้งานให้แก้ไขข้อมูลส่วนบุคคลของผู้ใช้งานให้ถูกต้อง
            สมบูรณ์และเป็นปัจจุบัน
            <br />
            <BoldText>
              {indent()}
              {indent()}7.3.2{" "}
            </BoldText>
            ข้อมูลส่วนบุคคลของผู้ใช้งานถูกเก็บรวบรวม
            ใช้หรือเปิดเผยโดยมิชอบด้วยกฎหมาย
            <br />
            <BoldText>
              {indent()}
              {indent()}7.3.3{" "}
            </BoldText>
            เมื่อข้อมูลส่วนบุคคลของผู้ใช้งานหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ของผู้ควบคุมข้อมูลส่วนบุคคลซึ่งได้แจ้งไว้ในการเก็บรวบรวม
            แต่ผู้ใช้งานประสงค์ให้ผู้ควบคุมข้อมูลส่วนบุคคลเก็บรักษาข้อมูลนั้นต่อไปเพื่อประกอบการใช้สิทธิตามกฎหมายของผู้ใช้งาน
            <br />
            <BoldText>
              {indent()}
              {indent()}7.3.4{" "}
            </BoldText>
            เมื่ออยู่ในช่วงเวลาที่ผู้ควบคุมข้อมูลส่วนบุคคลกำลังพิสูจน์ให้ผู้ใช้งานเห็นถึงเหตุอันชอบด้วยกฎหมายในการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้งาน
            หรือตรวจสอบความจำเป็นในการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งานเพื่อประโยชน์สาธารณะ
            อันเนื่องมาจากการที่ผู้ใช้งานได้ใช้สิทธิคัดค้านการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน
            <br />
            {indent()}
            <BoldText>7.4 </BoldText>สิทธิในการคัดค้านการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน
            เว้นแต่กรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลมีเหตุในการปฏิเสธคำขอของผู้ใช้งานโดยชอบด้วยกฎหมาย
            เช่น
            คำร้องขอใช้สิทธิที่ไม่สุจริต/ไม่สมเหตุสมผล/ไม่สามารถปฏิบัติได้จริง
            หรืออาจปฏิเสธคำร้องขอของผู้ใช้งานตามหลักเกณฑ์อื่นใดที่กฎหมายกำหนด
            เป็นต้น
            <br />
            {indent()} <BoldText>7.5 </BoldText>สิทธิในการเพิกถอนความยินยอม
            ในกรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลอาศัยความยินยอมในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของท่าน
            ท่านมีสิทธิในการเพิกถอนความยินยอมในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไว้แก่ผู้ควบคุมข้อมูลส่วนบุคคลได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่ในความครอบครองของผู้ควบคุมข้อมูล{" "}
            <br />
            {indent()}
            <BoldText>7.6 </BoldText>สิทธิในการลบข้อมูลส่วนบุคคล
            ท่านอาจขอให้ผู้ควบคุมข้อมูลส่วนบุคคลลบหรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวตนได้ในกรณีที่ข้อมูลส่วนบุคคลของท่านหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่กำหนดในการเก็บรวบรวม
            ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน
            หรือเมื่อท่านถอนความยินยอมที่เป็นบานในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคล หรือเมื่อท่านได้คัดค้านการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของท่านตามข้อ 7.4 หรือเมื่อการเก็บรวบรวม
            ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านไม่ชอบด้วยกฎหมาย
            <br />
          </Text>
          <SubTopic>8. การมีส่วนร่วมของเจ้าของข้อมูลส่วนบุคคล</SubTopic>
          <Text>
            {indent()}ก่อนที่ผู้ควบคุมข้อมูลส่วนบุคคลจะทำการเก็บรวบรวมข้อมูล ใช้
            หรือเปิดเผยข้อมูลของผู้ใช้งาน
            ผู้ควบคุมข้อมูลส่วนบุคคลจะทำการขอความยินยอมจากผู้ใช้งานก่อน
            (Consent) โดยการขอความยินยอม ผู้ควบคุมข้อมูลส่วนบุคคลจะทำโดยชัดเจน
            ชัดแจ้งและไม่คลุมเครือ
            <br />
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลจะเปิดเผยข้อมูลส่วนบุคคลต่อเมื่อได้รับคำร้องขอจากเจ้าของข้อมูลส่วนบุคคล
            ผู้สืบสิทธิ์ ทายาท ผู้แทนโดยชอบธรรม
            หรือผู้อนุบาลหรือผู้พิทักษ์ตามกฎหมาย
            โดยส่งคำร้องขอผ่านทางจดหมายอิเล็กทรอนิกส์ ที่ระบุท้ายประกาศ
            <br />
            {indent()}ทั้งนี้
            ผู้ควบคุมข้อมูลส่วนบุคคลอาจปฏิเสธสิทธิตามวรรคสองได้ตามกรณีที่มีกฎหมายกำหนด
            หรือในกรณีที่ข้อมูลส่วนบุคคลของผู้ใช้งานถูกทำให้ไม่ปรากฏชื่อหรือสิ่งบอกลักษณะอันสามารถระบุตัวผู้ใช้งานได้
            หรือผู้ใช้งานไม่สามารถพิสูจน์ได้จริงว่าข้อมูลส่วนบุคคลดังกล่าวเป็นของผู้ใช้งาน
            <br />
            {indent()}ในกรณีที่เจ้าของข้อมูล ผู้สืบสิทธิ์ ทายาท ผู้แทนโดยชอบธรรม
            หรือผู้พิทักษ์ตามกฎหมายมีการคัดค้านการจัดเก็บ ความถูกต้อง
            หรือการกระทำใด ๆ เช่น การแจ้งดำเนินการปรับปรุงแก้ไขข้อมูลส่วนบุคคล
            ผู้ดูแลเว็บแอปฯ
            จะดำเนินการบันทึกหลักฐานคำคัดค้านดังกล่าวไว้เป็นหลักฐานด้วย
            <br />
          </Text>
          <SubTopic>9. ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</SubTopic>
          <Text>
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลจะเก็บรักษาข้อมูลส่วนบุคคลของผู้ใช้งานเป็นระยะเวลา
            ไม่เกิน 6 เดือน หรือเมื่อได้รับคำสั่งการจากผู้มีอำนาจ ทั้งนี้
            เมื่อพ้นระยะเวลาดังกล่าวผู้ควบคุมข้อมูลจะทำการ
            <br />
            {indent()}
            {indent()}- ลบ ทำลายเมื่อหมดความจำเป็นในการใช้ข้อมูลส่วนบุคคลนั้น
            หรือ
            <br />
            {indent()}
            {indent()}-
            ทำให้ข้อมูลส่วนบุคคลของผู้ใช้งานไม่สามารถระบุตัวตนได้เพื่อการใช้ประโยชน์ด้านอื่น
            เช่น การวิเคราะห์ทางสถิติ และการปรับปรุงประสิทธิภาพการทำงาน <br />
          </Text>
          <SubTopic>10. การรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล</SubTopic>
          <Text>
            {indent()}
            เพื่อให้มั่นใจได้ว่าบุคลากรเหล่านั้นจะปฏิบัติตามข้อกำหนดของคำประกาศฉบับนี้ตามนโยบายความเป็นส่วนตัวของผู้ควบคุมข้อมูลส่วนบุคคล
            และของกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลที่ใช้บังคับ
            ข้อมูลส่วนบุคคลทั้งหลายทั้งปวงที่ผู้ใช้งานได้นำเข้าสู่ระบบของเว็บแอปฯ
            จะเข้าถึงได้โดยบุคลากรของผู้ควบคุมข้อมูลส่วนบุคคลที่มีหน้าที่ที่เกี่ยวข้อง
            และได้รับอนุญาตแล้วเท่านั้น หรือให้แก่ผู้ที่มีหน้าที่ที่เกี่ยวข้อง
            ที่ได้รับอนุญาตหรือมอบหมายจากผู้ควบคุมข้อมูลส่วนบุคคลให้เข้าถึงข้อมูลส่วนบุคคลดังกล่าวได้
            ทั้งนี้
            เพื่อการดำเนินการตามวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้เท่านั้น
            อย่างไรก็ตาม
            ไม่มีวิธีการจัดเก็บข้อมูลทางอิเล็กทรอนิกส์ใดที่จะมีความปลอดภัยที่สมบูรณ์{" "}
            <br />
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลมีมาตรการในการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคลของผู้ใช้งานอย่างเหมาะสม
            ทั้งในเชิงเทคนิคและการบริหารจัดการ เพื่อป้องกันมิให้ข้อมูลสูญหาย
            หรือมีการเข้าถึง ทำลาย ใช้ เปลี่ยนแปลง แก้ไข
            หรือเปิดเผยข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาต
            <br />
            {indent()}นอกจากนี้
            ผู้ควบคุมข้อมูลส่วนบุคคลได้กำหนดให้มีนโยบายการคุ้มครองข้อมูลส่วนบุคคลขึ้นโดยประกาศให้ทราบกันโดยทั่วกัน
            พร้อมแนวทางปฏิบัติเพื่อให้เกิดความมั่นคงปลอดภัยในการเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคล โดยธำรงไว้ซึ่งความเป็นความลับ
            (Confidentiality) ความถูกต้องครบถ้วน (Integrity) สภาพพร้อมใช้งาน
            (Availability) ของข้อมูลส่วนบุคคล ทั้งนี้ได้จัดให้มีการพิสูจน์ตัวตน
            (Authentication)
            เพื่อให้มั่นใจได้ว่าสิทธิการเข้าใช้บริการหรือฟังก์ชันที่เกี่ยวข้องกับข้อมูลส่วนบุคคลต้องผ่านกระบวนการยืนยันตัวตน
            อีกทั้งเมื่อยืนยันตัวตนแล้วได้จัดให้มีการกำหนดสิทธิ (Authorization)
            การเข้าถึงข้อมูลส่วนบุคคล เท่าที่จำเป็นกับบริการหรือฟังก์ชันเท่านั้น
            <br />
          </Text>
          <SubTopic>
            11. ความรับผิดชอบของบุคคลซึ่งประมวลผลข้อมูลส่วนบุคคล
          </SubTopic>
          <Text>
            {indent()}
            ผู้ควบคุมข้อมูลส่วนบุคคลได้กำหนดให้เจ้าหน้าที่เฉพาะผู้ที่มีอำนาจหน้าที่เกี่ยวข้องในการจัดเก็บรวบรวม
            ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของกิจกรรมการประมวลผลนี้เท่านั้นที่จะสามารถเข้าถึงข้อมูลส่วนบุคคลของผู้ใช้งานได้
            โดยผู้ดูแลเว็บแอปฯ
            จะดำเนินการให้เจ้าหน้าที่ปฏิบัติตามประกาศนี้อย่างเคร่งครัด
          </Text>
          <SubTopic>
            12. การเปลี่ยนแปลงแก้ไขคำประกาศเกี่ยวกับความเป็นส่วนตัว
          </SubTopic>
          <Text>
            {indent()}ในการปรับปรุงหรือเปลี่ยนแปลงประกาศนี้
            ผู้ควบคุมข้อมูลส่วนบุคคลอาจพิจารณาแก้ไขเปลี่ยนแปลงตามที่เห็นสมควร
            และจะทำการแจ้งให้ผู้ใช้งานทราบผ่านเว็บแอปฯ หัวข้อ
            คำประกาศเกี่ยวกับความเป็นส่วนตัว
            โดยมีวันที่ของเวอร์ชันล่าสุดกำกับอยู่ตอนท้าย อย่างไรก็ดี
            ผู้ควบคุมข้อมูลส่วนบุคคลขอแนะนำให้ผู้ใช้งานโปรดตรวจสอบเพื่อรับทราบประกาศฉบับใหม่อย่างสม่ำเสมอ
            โดยเฉพาะก่อนที่ผู้ใช้งานจะเปิดเผยข้อมูลส่วนบุคคลแก่ผู้ควบคุมข้อมูลส่วนบุคคล
            <br />
            {indent()}โดยในการเข้าใช้งานเว็บแอปฯนี้ของผู้ใช้งาน
            ถือเป็นการรับทราบตามข้อตกลงในประกาศนี้ ทั้งนี้
            โปรดหยุดการใช้งานหากผู้ใช้งานไม่เห็นด้วยกับข้อตกลงในประกาศฉบับนี้
            หากผู้ใช้งานยังคงใช้งานต่อไปภายหลังจากที่ประกาศนี้มีการแก้ไขและนำขึ้นประกาศในช่องทางข้างต้นแล้ว
            จะถือว่าผู้ใช้งานได้รับทราบการเปลี่ยนแปลงดังกล่าวแล้ว
            <br />
          </Text>
          <SubTopic>13. การติดต่อสอบถาม</SubTopic>
          <Text>
            {indent()}ผู้ใช้งานสามารถติดต่อสอบถามเกี่ยวกับประกาศฉบับนี้ได้ที่
            <br />
            {indent()}
            <BoldText>
              เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer: DPO)
            </BoldText>
            <br />
            {indent()}ชื่อ: <BoldText>นายสุรวิชญ์ ศรีคาร</BoldText>
            <br />
            {indent()}สถานที่ติดต่อ: กองกิจการนิสิต สำนักงานอธิการบดี
            มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย อาคาร เรียนรวมโซน A ชั้น A300
            ชั้น 3 เลขที่ 79 ถนนพหลโยธิน ตำบลลำไทร อำเภอวังน้อย
            จังหวัดพระนครศรีอยุธยา รหัสไปรษณีย์ 13170
            <br />
            {indent()}ช่องทางการติดต่อ: <br />
            {indent()}
            {indent()}โทรศัพท์ <ALink href="tel://035248000">035-248000</ALink>{" "}
            <span>ต่อ 8401 8402 8405 8406 8408</span>
            <br />
            {indent()}
            {indent()}อีเมล{" "}
            <ALink href="mailto: markvocal2@gmail.com">
              markvocal2@gmail.com
            </ALink>
          </Text>
          <center>
            <Text>ประกาศ ณ วันที่ 16 มกราคม 2566</Text>
          </center>
        </ContentContainer>
      </Container>
    </Background>
  );
};

const BoldText = styled.span`
  font-weight: 700;
`;

const Link = styled(BoldText)`
  color: #ff6a40;
  cursor: pointer;
`;

const ALink = styled.a`
  font-weight: 700;
  color: #ff6a40;
  cursor: pointer;
`;

const Topic = styled.h1`
  font-size: 40px;
  color: #ff6a40;
`;

const Text = styled.p`
  font-size: 16px;
`;

const SubTopic = styled.h2`
  color: #047751;
`;

const Background = styled.div`
  background: #fffbeb;
  font-family: "Noto Sans Thai", "Noto Sans";
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 1144px;
  background: #ffffff;
`;

const ContentContainer = styled.div`
  margin-top: 24px;
  margin-left: 116px;
  margin-right: 116px;
  margin-bottom: 24px;

  ${responsive.tablet(css`
    // margin-top: 24px;
    // max-width: 834px;
    // margin: auto;
    // margin-bottom: 24px;
    margin: 24px 24px 24px 24px;
  `)}

  ${responsive.mobile(css`
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 24px;
  `)}
`;

export default PrivacyNotice;
